import { Slot, Skeleton, Text } from '@costar-ui/components';
import { IconTrophy } from '@costar-ui/icons/csg/IconTrophy';
import React from 'react';

var Awards = function Awards(props) {
  var powerBroker = props.powerBroker,
    impactAward = props.impactAward,
    costarAward = props.costarAward,
    labels = props.labels,
    skeletonCount = props.skeletonCount,
    testId = props.testId,
    isLoading = props.isLoading;
  return isLoading ? /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "lg",
    className: "csg-tw-skeleton-awards"
  }, skeletonCount === 2 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.0"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.0"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.0"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.0"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.0"
  }))) : (powerBroker || costarAward || impactAward) && /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "lg",
    testId: testId
  }, powerBroker ? /*#__PURE__*/React.createElement(Slot, {
    gap: "sm",
    alignItems: "center",
    testId: "awards-power-broker"
  }, /*#__PURE__*/React.createElement(IconTrophy, {
    size: "0.9rem",
    className: "min-w-3.5 text-accent-highlight"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "text-14",
    testId: "awards-power-broker-label",
    className: "wrap-anywhere"
  }, labels === null || labels === void 0 ? void 0 : labels.powerBroker)) : null, costarAward ? /*#__PURE__*/React.createElement(Slot, {
    gap: "sm",
    alignItems: "center",
    testId: "awards-costar-award"
  }, /*#__PURE__*/React.createElement(IconTrophy, {
    size: "0.9rem",
    className: "min-w-3.5 text-primary-contrast"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "text-14",
    testId: "awards-costar-award-label",
    className: "wrap-anywhere"
  }, labels === null || labels === void 0 ? void 0 : labels.costarAward)) : null, impactAward ? /*#__PURE__*/React.createElement(Slot, {
    gap: "sm",
    alignItems: "center",
    testId: "awards-impact-award"
  }, /*#__PURE__*/React.createElement(IconTrophy, {
    size: "0.9rem",
    className: "min-w-3.5 text-primary"
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "text-14",
    testId: "awards-impact-award-label",
    className: "wrap-anywhere"
  }, labels === null || labels === void 0 ? void 0 : labels.impactAward)) : null);
};

export { Awards };
//# sourceMappingURL=awards.esm.js.map
